import { useMutation } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import { z } from 'zod/v4';

import { type ApiError, type ApiResponse, useAxiosInstance } from './utils';
import { addActionNameToMutationResult } from './utils/add-action-name-to-mutation-result';

const updateInvoiceDatesVariablesSchema = z.object({
  id: z.string(),
  issueDate: z.string(),
  dueDate: z.string(),
});

export type UpdateInvoiceDatesVariables = z.infer<typeof updateInvoiceDatesVariablesSchema>;

export async function updateInvoiceDatesFn(
  axiosInstance: Promise<AxiosInstance>,
  data: UpdateInvoiceDatesVariables,
) {
  const instance = await axiosInstance;

  return instance.put(
    `invoices/${data.id}/update_dates`,
    updateInvoiceDatesVariablesSchema.parse(data),
  );
}

export function useUpdateInvoiceDates() {
  const axiosInstance = useAxiosInstance();

  const mutation = useMutation<ApiResponse, ApiError, UpdateInvoiceDatesVariables>({
    mutationFn: variables => updateInvoiceDatesFn(axiosInstance, variables),
    onSuccess: () => {},
  });

  return addActionNameToMutationResult<
    ApiResponse,
    ApiError,
    UpdateInvoiceDatesVariables,
    'updateInvoiceDates'
  >('updateInvoiceDates', mutation);
}
